import React from "react"
import "./buildOnCeler.scss"
import cBridgeSDKcBridgeSDKPng from "../../images/home/cBridgeSDKcBridgeSDK.png"
import CelerInterchainMessageSDK from "../../images/home/CelerInterchainMessageSDK.png"
import { homeLinks } from "../../constants"

const buildOnCelerList = [
  {
    name: "cBridge SDK",
    descs: [
      "Integrate cBridge as part of your application workflow",
      "Integrate cBridge web-widget to allow users to easily bridge assets all from within your dApp",
      "Enable your protocol’s token for multi-chain expansion",
    ],
    img: cBridgeSDKcBridgeSDKPng,
    linkList: [
      {
        linkName: "SDK Doc",
        linkHref: homeLinks.buildOnCeler.cBridgeSDK.sdkDoc,
      },
      {
        linkName: "List your token",
        linkHref: homeLinks.buildOnCeler.cBridgeSDK.listYourToken,
      },
    ],
  },
  {
    name: "Celer Inter-chain Message SDK",
    descs: [
      "Build exciting inter-chain dApps such as:\n Lending: Collateral on one chain, borrow on another",
      "NFT Market: Bid on auctions taking place on a different chain",
      "Yield aggregators: Multi-chain yield optimization with single-chain UX",
      "Multi-chain metaverse games",
      "DAO governance from any chain",
    ],
    img: CelerInterchainMessageSDK,
    linkList: [
      {
        linkName: "SDK Doc",
        linkHref: homeLinks.buildOnCeler.celerInterChainMessageSDK.sdkDoc,
      },
      {
        linkName: "Partner onboard",
        linkHref:
          homeLinks.buildOnCeler.celerInterChainMessageSDK.partnerOnboard,
      },
    ],
  },
]

export default function BuildOnCeler() {
  return (
    <div className="buildOnCeler-bg">
      <div className="buildOnCeler">
        <div className="buildOnCeler-top">
          <div>Build on Celer</div>
        </div>
        <div className="buildOnCeler-bottom">
          {buildOnCelerList.map(item => {
            return (
              <div className="buildOnCeler-bottom-content">
                <div className="content-icon">
                  <img src={item.img} alt=""/>
                </div>
                <div className="content-title">{item.name}</div>
                <div className="content-desc">
                  <ul className="desc-list">
                    {item.descs.map(descItem => {
                      return <li>{descItem}</li>
                    })}
                  </ul>
                </div>
                <div className="content-link">
                  {item.linkList.map(link => {
                    return (
                      <a
                        href={link.linkHref}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.linkName}
                      </a>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
